import React from 'react';
import ReactDOM from 'react-dom';
import './styles/normalize.css';
import './styles/base.css';
import './index.css';
import Routes from 'Routes';
import Auth from './shared/auth';
//import reportWebVitals from './reportWebVitals';


// Initialize Pendo
const initializeApp = async () => {
    // Get user profile from Auth
    const auth = new Auth();
    const profile = auth.getProfile();
    console.log(profile);

    // Render the app
    ReactDOM.render(
        <React.StrictMode>
            <Routes />
        </React.StrictMode>,
        document.getElementById('root')
    );
};

initializeApp();